module.exports = __webpack_public_path__ + "img/4.f92e11b4.jpg";